module.exports = __webpack_public_path__ + "img/down2.dbf980a1.png";